// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"55010a57","732":"69fc5d17"}[chunkId] + ".chunk.js";
};